import { render, staticRenderFns } from "./AddUpdateUserModal.vue?vue&type=template&id=f133ca42"
import script from "./AddUpdateUserModal.vue?vue&type=script&lang=js"
export * from "./AddUpdateUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports